import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import GetHelpForm from "../components/features/GetHelpForm";
import StatusStudentPage from "../components/features/StatusStudentPage";
import { sendMessage, listenToMessages } from "../wsFunctions/socket";

function Student() {
    // Hente og omformulere url-parametere
    const { kategoriEncoded, tallidEncoded } = useParams(); // btoa (encrypt) - atob (decrypt)
    const kategori = atob(kategoriEncoded);
    const tallid = atob(tallidEncoded);

    // Definerer 'subject' som en state for å opprettholde riktig data
    const [subject, setSubject] = useState("none");
    const [countdown, setCountdown] = useState(90); //90
    const [status, setStatus] = useState(undefined); //undefined
    const [banText, setBanText] = useState("Loader ...");
    useEffect(() => {
        if (status!==undefined) {return}
        if (countdown <= 0) {window.location.href = "https://google.com"}
        function inHours() {            
            const now = new Date();
            let hour = now.getHours();
            hour = hour + now.getMinutes()/60;
            const day = now.getDay();
            if (day === 1) {
                if (!(13.5 <= hour && hour <= 16.5)) {
                    window.location.href = "https://leksehjelp-bjerke.no";
                };
            } else if (day === 2) {
                if (!(15.16 <= hour && hour <= 17.17)) {
                    window.location.href = "https://leksehjelp-bjerke.no";
                };
            } else {
                window.location.href = "https://leksehjelp-bjerke.no";
            };
        };

        inHours();

        const listner = listenToMessages((e) => {
            if (e.data.type === "verification-result") {
                setBanText(e.data.data.banText);
            } else if (e.data.type === "help-request-recieved") {
                setStatus(false);
            } else if (e.data.type === "help-request-coming") {
                setStatus(true);
            };
        });
        
        const timer = setInterval(() => {
            setCountdown(prev => prev-1);
        }, 1000);
        sendMessage({type: "verify", data: {userID: localStorage.getItem("userID"), location: [kategori, tallid]}})

        return () => {
            clearInterval(timer)
            listner();
        };
    }, [kategori, tallid]);

    return (
        <>
        {
            banText ? <p>{banText}</p> : <main>
                <div id="info-student-page">
                    <b><p>Denne siden gjelder: {kategori} {tallid}</p></b>
                    <p style={{display: ((status===undefined) ? "block" : "none")}}>Siden lukkes om <b>{countdown} sekunder</b> dersom du ikke sender en forespørsel om hjelp.</p>
                </div>
                {/* Status oversikt som vises etter en forespørsel er sendt */}
                <StatusStudentPage setStatus={setStatus} status={status}/>
                <GetHelpForm setStatus={setStatus} setSubject={setSubject} subject={subject} status={status} category={kategori} number={tallid} />
            </main>
        }
        </>
    );
};

export default Student;